<template>
	<div class="row mb-2 position-relative">
		<div class="col-md-12">
			<h5 class="bg-info py-1 px-2">Day {{ id }}</h5>
		</div>
		<div class="form-group col-sm-6 mb-5">
			<BaseInput
				name="title"
				label="Title"
				type="text"
				v-model="data.title"
				class="form-control form-control-lg dashInput"
				rules="required|min:4"
				@valError="inputError"
				@valSuccess="inputSuccess"
			/>
		</div>
		<div class="form-group col-sm-6 mb-2">
			<BaseMultiSelect
				@change:value="getCities"
				@update:value="setCity"
				:options="multiSelectState.citiesOptions"
				:defaultData="data.city.id"
				rules="required"
				name="City"
				:required="true"
				@valError="inputError"
				@valSuccess="inputSuccess"
			/>
		</div>
		<div class="form-group col-sm-6 mb-5">
			<BaseMultiSelect
				@update:value="setSight"
				:options="multiSelectState.sightsOptions"
				:defaultData="editableData.sight"
				rules="required"
				mode="multiple"
				name="Select Sights"
				@valError="inputError"
				@valSuccess="inputSuccess"
			/>
		</div>
		<div class="form-group col-sm-6 mb-5">
			<BaseInput
				name="placeName"
				label="Place Name"
				type="text"
				class="form-control form-control-lg dashInput"
				v-model="data.placeName"
				rules="required|min:4"
				@valError="inputError"
				@valSuccess="inputSuccess"
			/>
		</div>
		<div v-if="leadPackage" class="form-group row mb-4">
			<div class="form-group col-sm-6 mb-4">
				<BaseMultiSelect
					@update:value="setHotel"
					:options="multiSelectState.hotelsSelect"
					:defaultData="data?.hotel"
					rules="required"
					name="Select Hotel"
					mode="single"
					@valError="inputError"
					@valSuccess="inputSuccess"
				/>
			</div>
			<div class="col-sm-6">
				<div class="row pt-4 ps-2">
					<div
						v-for="(roomType, index) in multiSelectState.roomTypes"
						:key="`${index}-roomType`"
						class="col-sm-6"
					>
						<RoomTypeAndCount
							@updateData="updateRoomData"
							@removeData="removeRoomData"
							:name="roomType.type"
							:hotelId="roomType.hotelId"
							:capacity="roomType.capacity"
							:price="roomType.price"
							:id="index"
							:defaultData="data?.rooms"
						/>
					</div>
				</div>
			</div>
		</div>

		<div v-if="leadPackage" class="form-group row mb-4">
			<div class="form-group col-sm-6">
				<BaseMultiSelect
					@update:value="setTransporter"
					:options="multiSelectState.transportersSelect"
					rules="required"
					name="Transporter"
					mode="single"
					@valError="inputError"
					@valSuccess="inputSuccess"
					:defaultData="data?.transporter"
				/>
			</div>
			<div class="form-group col-sm-6">
				<BaseMultiSelect
					@update:value="setVehicle"
					:options="multiSelectState.vehiclesSelect"
					rules="required"
					name="Vehicle"
					mode="tags"
					@valError="inputError"
					@valSuccess="inputSuccess"
					:defaultData="data?.vehicles"
				/>
			</div>
		</div>

		<div
			class="form-group col-sm-3 mb-4 d-flex justify-content-space-between align-items-center"
		>
			<input
				class="form-check-input"
				type="checkbox"
				v-model="data.meal"
				id="flexCheckIndeterminate"
				value="breakfast"
			/>
			<label
				class="form-check-label mx-1 pt-1 text-dark"
				for="flexCheckIndeterminate"
			>
				Breakfast
			</label>
		</div>
		<div
			class="form-group col-sm-3 mb-4 d-flex justify-content-space-between align-items-center"
		>
			<input
				class="form-check-input"
				type="checkbox"
				v-model="data.meal"
				id="flexCheckIndeterminate"
				value="lunch"
			/>
			<label
				class="form-check-label mx-1 pt-1 text-dark"
				for="flexCheckIndeterminate"
			>
				Lunch
			</label>
		</div>

		<div
			class="form-group col-sm-3 mb-4 d-flex justify-content-space-between align-items-center"
		>
			<input
				class="form-check-input"
				type="checkbox"
				v-model="data.meal"
				id="flexCheckIndeterminate"
				value="dinner"
			/>
			<label
				class="form-check-label mx-1 pt-1 text-dark"
				for="flexCheckIndeterminate"
			>
				Dinner
			</label>
		</div>

		<div class="form-group col-sm-12 mb-2 small text-dark">
			<BaseTextArea
				v-model="data.details"
				name="Details"
				label="Details"
				rules="required|min:10"
				@valError="inputError"
				@valSuccess="inputSuccess"
			/>
		</div>
		<!-- <span
			v-if="id !== 0"
			@click="$emit('removeComponent', id)"
			class="mx-2 position-absolute top-100 start-100 translate-middle badge rounded-pill bg-danger cursor-pointer"
			><i class="bi bi-x"></i
		></span> -->
	</div>
</template>
<script>
	import { reactive, watch, inject } from "vue";
	import FormCheck from "@/helpers/formCheckHelper";
	import Helper from "@/helpers/dataHelper";
	import API from "@/config/api";
	import toast from "@/config/toast";

	import BaseInput from "./BaseInput";
	import BaseMultiSelect from "./BaseMultiSelect";
	import BaseTextArea from "./BaseTextArea";
	import RoomTypeAndCount from "@/components/RoomTypeAndCount";

	export default {
		name: "Itinerary",
		components: {
			BaseInput,
			BaseMultiSelect,
			BaseTextArea,
			RoomTypeAndCount,
		},
		props: {
			id: {
				type: Number,
				default: 0,
			},
			defaultData: {
				type: [Object, String],
				default: "",
			},
			leadPackage: {
				type: Boolean,
				default: false,
			},
		},
		emits: ["formError", "formSuccess"],
		setup: (props, { emit }) => {
			const packageEditState = inject("packageEditState");
			const masterStore = inject("masterStore");
			const data = reactive({
				id: props.id,
				title: null,
				placeName: null,
				meal: [],
				city: {
					id: null,
					name: null,
					state_name: null,
				},
				day: props.id,
				details: null,
				sightSeeing: [],
				hotel: null,
				rooms: [],
				transporter: null,
				vehicles: [],
			});

			const multiSelectState = reactive({
				sights: [],
				sightsOptions: [],
				cities: [],
				citiesOptions: [],
				hotels: [],
				roomTypes: [],
				hotelsSelect: [],
				vehicles: [],
				vehiclesSelect: [],
				transporters: [],
				transportersSelect: [],
			});
			const formState = reactive({
				disable: true,
			});
			const nullable = ["id", "meals"];

			// functionality for edit data::start

			const editableData = reactive({
				city: 0,
				sight: [],
			});

			// functionality for edit data::end

			const getSights = async (queryObj) => {
				console.log("get sight --")
				try {
					const response = await API.privateRequest.get(
						`sights?city=${queryObj?.city || ""}&state=${
							queryObj?.state || ""
						}`,
					);
					const sights = response.data.data;
					multiSelectState.sights = sights;
					const changeFormat = sights.map((sight) => {
						return {
							label: `${sight.activity} (${sight.city.name})`,
							value: sight._id,
						};
					});

					multiSelectState.sightsOptions = [
						...multiSelectState.sightsOptions,
						...changeFormat,
					];
				} catch (err) {
					let message;
					if (err?.response?.status < 500 && err?.response?.status >= 400) {
						message = err.response.data.message;
					} else if (err?.response?.status >= 500) {
						message = "Oops! something went wrong";
					} else {
						message = "App Error";
					}

					toast.error(message, true);
				}
			};

			const setSight = (payload) => {
				if (!Object.keys(payload).length) {
					data.sightSeeing = [];
					return;
				}
				data.sightSeeing = [...payload];
			};

			// ! City Functions

			const getCities = async (cityObj) => {
				let data = {};
				if (cityObj?.country) {
					data.countryName = cityObj.country;
				} else if (cityObj?.name.length < 3) return;
				else data.name = cityObj.name;

				try {
					const cities = await Helper.getCities(data);

					if (
						props.defaultData instanceof Object &&
						Object.values(props.defaultData?.city).length
					) {
						multiSelectState.cities = [
							{
								name: props.defaultData.city.name,
								id: props.defaultData.city.id,
								state_name: props.defaultData.city.state_name || "",
							},
							...cities,
						];
					} else multiSelectState.cities = cities;

					const changeFormat = cities.map((city) => {
						return {
							label: `${city.name} (${city.state_name})`,
							value: city.id,
						};
					});
					if (
						props.defaultData instanceof Object &&
						Object.values(props.defaultData.city).length
					) {
						multiSelectState.citiesOptions = [
							{
								label: `${props.defaultData.city.name} (${
									props.defaultData.city?.state_name || ""
								})`,
								value: props.defaultData.city.id,
							},
							...changeFormat,
						];
					} else multiSelectState.citiesOptions = [...changeFormat];
				} catch (error) {
					console.log(error);
				}
			};

			getCities({
				country: packageEditState.state.data?.country?.name || "India",
			});

			const setCity = (dataObj) => {
				if (!dataObj) {
					data.city.id = 0;
					data.city.name = null;
					data.city.state_name = null;
					return;
				}
				// ? finding selected city data
				const city = multiSelectState.cities.filter(
					(city) => city.id === dataObj,
				);

				data.city.id = city[0].id;
				data.city.name = city[0].name;
				data.city.state_name = city[0].state_name;

				getSights({ city: data.city.name, state: data.city.state_name });
				getHotels(`state=${data.city.state_name}`);
				getTransporters(data.city.state_name);
			};

			// event handler for input validation event
			const inputError = (input) => {
				// let check = FormCheck.valError(input, data, nullable);
				// formState.disable = check;
			};

			const inputSuccess = (input) => {
				// let check = FormCheck.valSuccess(input, data, nullable);
				// formState.disable = check;
			};

			watch(
				() => data,
				(preValue, newValue) => {
					if (data.day && data.title && data.city.name) {
						emit("formSuccess", data);
						return;
					}
					emit("formError");
					return;
				},
				{ deep: true },
			);

			const getHotels = async (query) => {
				try {
					const response = await API.privateRequest.get(`hotels?${query}`);
					multiSelectState.hotels = response.data.data;
					const hotels = response.data.data.map((hotel) => ({
						label: `${hotel.name} (${hotel.city.name} - ${hotel.hotelType}-${hotel.starRating}-star)`,
						value: hotel._id,
					}));
					multiSelectState.hotelsSelect = [...hotels];
				} catch (err) {
					console.log("unable to get hotels");
				}

				if (masterStore.state.activeComponent === "edit") {
					setHotel(data.hotel);
				}
			};

			const setHotel = (payload) => {
				data.hotel = payload;
				setRoomTypes(payload);
			};

			const updateRoomData = (roomData) => {
				if (data.rooms.length) {
					let found = false;
					let newRooms = data.rooms.map((dataItem) => {
						let item = {...dataItem }
						if (
							item.roomType === roomData.roomType &&
							item.hotelId === roomData.hotelId
						) {
							found = true;
							item.roomCount = roomData.roomCount;
							item.hotelId = roomData.hotelId;
						}
						return dataItem
					});

					data.rooms = [...newRooms];

					if (found) return;
				}
				data.rooms.push(roomData);
			};

			const removeRoomData = (roomType) => {
				data.rooms = data.rooms.filter(
					(room) =>
						room.roomType !== roomType.name &&
						room.hotelId === roomType.hotelId,
				);
			};

			const setRoomTypes = (payload) => {
				let roomTypes = [];
				let hotels = multiSelectState.hotels.filter(
					(hotel) => hotel._id === payload,
				);

				hotels.map((hotel) => {
					hotel.roomTypes.map((type) => {
						roomTypes.push({
							hotelId: hotel._id,
							type: type.type,
							capacity: type.capacity,
							price: type.price,
						});
					});
				});

				multiSelectState.roomTypes = [...roomTypes];
				roomTypes = [];
			};

			const getTransporters = async (state) => {
				try {
					if (!state) throw Error("Please select a state");
					const response = await API.privateRequest.get(
						"transports?state=" + state,
					);
					multiSelectState.transporters = response.data.data;
					multiSelectState.transportersSelect = response.data.data.map(
						(transporter) => {
							return { label: transporter.name, value: transporter._id };
						},
					);
				} catch (err) {
					let message;
					if (err?.response?.status < 500 && err?.response?.status >= 400) {
						message = err.response.data.message;
					} else if (err?.response?.status >= 500) {
						message = "Oops! something went wrong";
					} else {
						message = "App Error";
					}

					toast.error(message, true);
				}
			};

			const setTransporter = (payload) => {
				data.transporter = payload;
				if (!payload) {
					multiSelectState.vehicles = [];
					return;
				}
				const transporter = multiSelectState.transporters.filter(
					(transporter) => transporter._id === payload,
				);

				const vehicles = transporter[0].vehicleData.filter(
					(vehicle) => vehicle.city.state_name === data.city.state_name,
				);

				multiSelectState.vehicles = vehicles[0].vehicles;
				multiSelectState.vehiclesSelect = multiSelectState.vehicles.map(
					(vehicle) => ({ label: vehicle.vehicleType, value: vehicle._id }),
				);
			};

			const setVehicle = (payload) => {
				data.vehicles = [...payload];
			};

			const setEditableData = () => {
				if (props.defaultData) {
					Object.keys(data).map(
						(key) => (data[key] = props.defaultData[key] || data[key]),
					);
				}

				if (data.sightSeeing.length) {
					data.sightSeeing.forEach((sight) => {
						editableData.sight.push(sight._id);
						multiSelectState.sightsOptions = [
							...multiSelectState.sightsOptions,
							{
								label: `${sight.activity} ${sight.city.name}`,
								value: sight._id,
							},
						];
					});
				}

				if (data.city?.id) {
					editableData.city = data.city.id;
					multiSelectState.citiesOptions = [
						{
							label: `${data.city.name} (${data.city?.state_name || ""})`,
							value: data.city.id,
						},
					];

					multiSelectState.cities = [
						{
							id: data.city.id,
							name: data.city.name,
							state_name: data.city.state_name || "",
						},
					];
				}

				if (props.leadPackage) {
					if (data.city.state_name) {
						getHotels(`state=${data.city.state_name}`);
						getTransporters(data.city.state_name);
					}
				}
			};

			// setting props data
			setEditableData();

			return {
				data,
				formState,
				multiSelectState,
				editableData,
				inputError,
				inputSuccess,

				getSights,
				setSight,
				getCities,
				setCity,
				setHotel,
				setTransporter,
				setVehicle,

				updateRoomData,
				removeRoomData,
			};
		},
	};
</script>
